import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  Header, Table, Container, Loader, Icon, Button
} from 'semantic-ui-react'
import { path } from 'ramda'
import ConfirmPopup from 'Components/ConfirmPopup'
import UserActions from 'Redux/UserRedux'
import TeamActions from 'Redux/TeamRedux'

class UsersList extends Component {
  componentDidMount () {
    this.props.teamsListRequest()
  }

  onUserDelete = (userId, teamId) => () => {
    this.props.usersDeleteRequest(userId, teamId)
  }

  render () {
    const teamId = path(['params', 'teamId'], this.props.match)
    const team = this.props.teams.find(team => team.id === Number(teamId))
    const isAdmin = team && team.admins.find(ad => {
      return ad.email === this.props.username
    })
    const colspan = isAdmin ? 2 : 1
    return (
      <Container>
        <Loader active={this.props.listFetching} />
        <Table celled fixed singleLine>
          <Table.Header fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan='2'>
                <Header as='h3'>Team Members</Header>
              </Table.HeaderCell>
              <Table.HeaderCell colSpan={colspan}>
                <Link to='users/new'>
                  <Button
                    floated='right'
                    icon
                    labelPosition='left'
                    primary
                    size='small'>
                      <Icon name='user' /> Add Member
                  </Button>
                </Link>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Email</Table.HeaderCell>
              <Table.HeaderCell>Role</Table.HeaderCell>
              {isAdmin &&
                <Table.HeaderCell>Action</Table.HeaderCell>
              }
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {team && team.admins.map((user, index) => (
              <Table.Row key={user.id}>
                <Table.Cell>{user.name}</Table.Cell>
                <Table.Cell>{user.email}</Table.Cell>
                <Table.Cell>Admin</Table.Cell>
                {isAdmin
                && user.email !== this.props.username
                &&
                  <Table.Cell>
                    <ConfirmPopup
                      trigger={
                        <Button
                          color='red'
                          basic
                          icon='remove'>
                        </Button>
                      }
                      onConfirm={this.onUserDelete(user.id, team.id)}
                    />
                  </Table.Cell>
                }
              </Table.Row>
            ))}

            {team && team.editors.map((user, index) => (
              <Table.Row key={user.id}>
                <Table.Cell>{user.name || 'NA'}</Table.Cell>
                <Table.Cell>{user.email}</Table.Cell>
                <Table.Cell>Editor</Table.Cell>
                {isAdmin
                && user.email !== this.props.username
                &&
                  <Table.Cell>
                    <ConfirmPopup
                      trigger={
                        <Button
                          color='red'
                          basic
                          icon='remove'>
                        </Button>
                      }
                      onConfirm={this.onUserDelete(user.id, team.id)}
                    />
                  </Table.Cell>
                }
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  listFetching: state.teams.listFetching || state.users.deleteFetching,
  username: state.auth.userData.email,
  teams: state.teams.listData
})

const mapDispatchToProps = (dispatch) => ({
  teamsListRequest: (projectId) =>
    dispatch(TeamActions.teamsListRequest(projectId)),
  usersCreateRequest: (params) =>
    dispatch(UserActions.usersCreateRequest(params)),
  usersDeleteRequest: (userId, teamId) =>
    dispatch(UserActions.usersDeleteRequest(userId, teamId))
})

export default connect(mapStateToProps, mapDispatchToProps)(UsersList)



// WEBPACK FOOTER //
// ./src/Pages/Users/List.js